<template>
  <div class="aside__subblock">
    <div class="aside__list">
      <div class="aside__item">
        <SelectIds
          v-model="item.courseId"
          title="Курс"
          placeholder="Выберите курс"
          icon="arrow-down-thick"
        ></SelectIds>
      </div>
      <div class="aside__item">
        <SelectTariff
          v-model="item.tariffId"
          title="Тариф"
          :error="$v.$dirty && !$v.item.tariffId.required"
          :select-data="courseList"
          placeholder="Выберите тариф"
          icon="arrow-down-thick"
        ></SelectTariff>
      </div>
      <div class="aside__item">
        <CustomSelect
          v-model="item.manager"
          title="Менеджер / Капитан"
          :user="id"
          :tracker-id="item.tracker && item.tracker.id ? item.tracker.id : ''"
          placeholder="Выберите менеджера / капитана"
          icon="arrow-down-thick"
        ></CustomSelect>
      </div>
      <div class="aside__item">
        <CustomSelect
          v-model="item.tracker"
          title="Трекер / Проверяющий"
          :user="id"
          :manager-id="item.manager && item.manager.id ? item.manager.id : ''"
          placeholder="Выберите трекера / проверяющего"
          icon="arrow-down-thick"
        ></CustomSelect>
      </div>
      <div class="aside__item">
        <Input v-model.trim="item.faculty" title="Факультет" placeholder="Факультут"></Input>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import SelectIds from './SelectIds';
import SelectTariff from './SelectIds/SelectTariff';
import SelectInAll from './SelectIds/SelectInAll';
import CustomSelect from './SelectIds/Select';

import { required } from 'vuelidate/lib/validators';

export default {
  components: { SelectIds, SelectTariff, CustomSelect, SelectInAll },
  props: ['value', 'id'],
  data() {
    return {
      item: {
        courseId: '',
        tariffId: '',
        manager: '',
        tracker: '',
        faculty: ''
      },
      itemBackUp: {
        courseId: '',
        tariffId: '',
        manager: '',
        tracker: '',
        faculty: ''
      }
    };
  },
  computed: {
    courseList() {
      const data = this.$store.state['users'].data['courseList'];
      if (this.item.courseId && data[this.item.courseId]) {
        return data[this.item.courseId].tariffs;
      }

      return [];
    }
  },
  watch: {
    value() {
      if (this.value) {
        this.item = _.cloneDeep(this.value);
        this.itemBackUp = _.cloneDeep(this.item);
      }
    },
    'item.courseId'() {
      this.$store.dispatch('users/getUsersDataList', {
        id: this.item.courseId
      });
      const formHasChanges = !_.isEqual(this.item, this.itemBackUp);
      if (formHasChanges) {
        this.$emit('compare', { ...this.item });
      }
    },
    'item.tariffId'() {
      const formHasChanges = !_.isEqual(this.item, this.itemBackUp);
      if (formHasChanges) {
        this.$emit('compare', { ...this.item });
      }
    },
    'item.manager'() {
      const formHasChanges = !_.isEqual(this.item, this.itemBackUp);
      if (formHasChanges) {
        this.$emit('compare', { ...this.item });
      }
    },
    'item.tracker'() {
      const formHasChanges = !_.isEqual(this.item, this.itemBackUp);
      if (formHasChanges) {
        this.$emit('compare', { ...this.item });
      }
    },
    // 'item.mentor'(){
    //   let formHasChanges = !_.isEqual(this.item, this.itemBackUp);
    //   if (formHasChanges) {
    //     this.$emit('compare', {...this.item})
    //   }
    // },
    'item.faculty'() {
      const formHasChanges = !_.isEqual(this.item, this.itemBackUp);
      if (formHasChanges) {
        this.$emit('compare', { ...this.item });
      }
    }
  },
  mounted() {
    if (this.value) {
      this.item = _.cloneDeep(this.value);
      this.itemBackUp = _.cloneDeep(this.item);
    }
  },
  validations() {
    return {
      item: {
        tariffId: { required }
      }
    };
  }
};
</script>
